__webpack_require__.p = "/dark_chess/";